import { ButtonBase, Typography } from '@material-ui/core'

import { persianRegex } from '../../helpers/regex'
import { lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { AddOnPolicy } from '../../types/cancelAndModifyPolicies'
import useCancelStyles from '../CancelPoliciesList/styles/PoliciesTable.styles'
import { AddOnPolicyRowMenu } from './AddOnPolicyRowMenu'
import { formatCutoff } from './formatCutoff'
import useStyles from './styles/AddOnPoliciesTable.styles'
import { useAddOnPolicyRowActions } from './useAddOnPolicyRowActions'

export interface AddOnPolicyRowProps {
  data: AddOnPolicy
  providerCode: string
  canEdit: boolean
  canDelete: boolean
}

const AddOnPolicyRow: React.FC<AddOnPolicyRowProps> = ({
  data,
  providerCode,
  canEdit,
  canDelete
}) => {
  const cancelClasses = useCancelStyles()
  const classes = useStyles()
  const { openTable, openDelete, dialogs } = useAddOnPolicyRowActions(
    data,
    providerCode
  )
  const isPersian = persianRegex.test(data.basicDetails.name)
  const translated = data.basicDetails.descriptionTranslatedList[0]?.value

  return (
    <div className={cancelClasses.tableRowRoot}>
      <ButtonBase
        className={classes.tableRow}
        component={LocalizedLink}
        disabled={!canEdit}
        to={`/policies/add-on-policies/${providerCode}/${data.basicDetails.id}/edit`}>
        <div className={cancelClasses.nameCell}>
          <Typography
            variant="h4"
            style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
            {data.basicDetails.name}
          </Typography>
        </div>
        <div className={cancelClasses.nameCell}>
          <Typography variant="body1">
            {formatCutoff(data.cutoffHours)}
          </Typography>
        </div>
        <div className={cancelClasses.descriptionCell}>
          <div
            dangerouslySetInnerHTML={{
              __html:
                lang === 'fa' && translated
                  ? translated
                  : data.basicDetails.description
            }}
          />
        </div>
      </ButtonBase>
      <div>
        <AddOnPolicyRowMenu
          id={data.basicDetails.id}
          providerCode={providerCode}
          canEdit={canEdit}
          canDelete={canDelete}
          openTable={openTable}
          openDelete={openDelete}
        />
      </div>
      {dialogs}
    </div>
  )
}

export default AddOnPolicyRow
